angular.module('cimerFrontEndApp').service('UserService', ['$q', '$http', 'ApiUrl', function ($q, $http, ApiUrl) {
    'use strict';
    var _apiUrl = ApiUrl.url('/User/');

    return {
        search: function (text, number) {
            if (!number) {
                number = 10;
            }
            var config = {
                params: { text: text, number: number },
                cache: true
            };
            return $http.get(_apiUrl + 'Search', config);
        }

    };
}]);